import React from 'react';
import { RadioButton } from 'primereact/radiobutton';

interface ISetupJourneyStepProps {
  no: number;
  title: string;
  enabled: boolean;
  isLastStep?: boolean;
}

export default function SetupJourneyStep({
  no,
  title,
  enabled,
  isLastStep,
}: ISetupJourneyStepProps) {
  return (
    <div className={`flex ${isLastStep ? '' : 'flex-1'} flex-col`}>
      <div className="flex gap-2 font-semibold">
        <div
          className={`text-2xl leading-6 ${
            enabled ? 'text-black' : 'text-[#73767F]'
          }`}
        >
          {no}
        </div>
        <div
          className={`flex-auto text-sm leading-5 ${
            enabled ? 'text-zinc-500' : 'text-[#C4C4C4]'
          }`}
        >
          {title}
        </div>
      </div>
      <div className="flex gap-4 mt-3.5">
        <RadioButton disabled />
        {isLastStep ? null : (
          <div className="shrink-0 my-auto border-solid bg-slate-300 border-[3px] border-slate-300 h-[3px] grow" />
        )}
      </div>
    </div>
  );
}
